import React from 'react';
import { Button } from '../connectedForm/Button';
import { ButtonPropsType } from '../connectedForm/Button/Button';
import {
  BorderlessTheme,
  DangerTheme,
  InfoTheme,
  SecondaryTheme,
  SuccessTheme,
  WarningTheme,
} from '../../styles/themes/default/defaultFluentTheme';

export const GridToolbarButton = (props: ButtonPropsType) => {
  return <Button {...props} padding="4px 5px" />;
};

export const DangerGridToolbarButton = (props: ButtonPropsType) => {
  return <GridToolbarButton {...props} theme={DangerTheme} />;
};

export const WarningGridToolbarButton = (props: ButtonPropsType) => {
  return <GridToolbarButton {...props} theme={WarningTheme} />;
};

export const InfoGridToolbarButton = (props: ButtonPropsType) => {
  return <GridToolbarButton {...props} theme={InfoTheme} />;
};

export const SuccessGridToolbarButton = (props: ButtonPropsType) => {
  return <GridToolbarButton {...props} theme={SuccessTheme} primary={true} />;
};

export const SecondaryGridToolbarButton = (props: ButtonPropsType) => {
  return <GridToolbarButton {...props} theme={SecondaryTheme} />;
};
